@if (displayPackages().length > 0) {
	@for (package of displayPackages(); track package.slug) {
		<vp-persuade-card
			[cardUrl]="package.cardUrl"
			[content]="package.bulletContent"
			[ctaText]="'global.more-information' | translate"
			[ctaUrl]="!package.isExpired && package.toUrl"
			[images]="package.images"
			[overline]="package.hotelName"
			[price]="package.price"
			[pricingToolTip]="{
				occupancy: pricingTooltipOccupancy,
			}"
			[showReadMore]="true"
			[title]="package.name"
		/>
	}
} @else {
	<vp-alert
		[content]="
			'storyblok.pages.filterable-list.no-results.hotels-description'
				| translate
		"
		[emphasized]="true"
		[title]="'storyblok.pages.filterable-list.no-results.title' | translate"
		type="dialog--warning"
	/>
}
